import { Job, useBuild } from "app/components/Playground/BuildContext";
import JobComponent from "app/components/job/Job";
import TriggerJobSummary from "../../Show/TriggerJobSummary";
import WaiterJobSummary from "../../Show/WaiterJobSummary";
import ManualJobSummary from "../../Show/ManualJobSummary";

export function JobListItem({
  job,
  isRetry = false,
  autoFollow = false,
}: {
  job: Job;
  isRetry?: boolean;
  autoFollow?: boolean;
}) {
  const { build, store } = useBuild();
  if (!build || !store) {
    return null;
  }

  switch (job.type) {
    case "script":
      return (
        <JobComponent
          key={job.id}
          job={job}
          build={build}
          buildStore={store}
          autoFollow={autoFollow}
        />
      );
    case "trigger":
      return <TriggerJobSummary key={job.id} job={job} isRetry={isRetry} />;
    case "manual":
      return <ManualJobSummary key={job.id} job={job} buildStore={store} />;
    case "waiter":
      return <WaiterJobSummary key={job.id} job={job} />;
  }
}
